module.exports = __webpack_public_path__ + "img/b.faf2587d.jpg";